import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { stateOptionsSample } from 'src/app/constants/service.constants';

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.scss']
})
export class RouteComponent implements OnInit {

  heading: string;
  content: any;
  formFields;
  routeForm = new UntypedFormGroup({
    comments: new UntypedFormControl('', Validators.required),
    activity_sub_type: new UntypedFormControl('', Validators.required),
    confirm_password: new UntypedFormControl('', Validators.required),
  })
  stateOptionsSample = stateOptionsSample;

  users = [
    {value:'1',label:'Venkat'},
    {value:'2',label:'Gopi'},
    {value:'3',label:'Siva'},
    {value:'4',label:'Upendra'},
  ] 

  constructor(public modalRef: NgbActiveModal) {}


  ngOnInit() {
  }

}
